import React from 'react'
import ProjectList from './components/ProjectList'
import { useQuery } from '@tanstack/react-query'
import { getCOProjects } from 'service/completionOptimizer'

const ProjectSummaryPage = () => {
  const { data: projects, refetch } = useQuery({
    queryKey: ['co_getProjectList'],
    queryFn: () => getCOProjects()
  })

  // Sort projects by updated_at in descending order
  const sortedProjects = React.useMemo(() => {
    if (!projects) return []
    
    return [...projects]
      .sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
      .map(p => ({
        id: p.pk,
        name: p.general?.title,
        type: p.general?.fluid,
        updated_date: p.updated_at,
        backupId: p.general?.id
      }))
  }, [projects])

  return (
    <div className="p-2" style={{
      overflowY: 'auto',
      height: '100vh',
      overflowX: 'hidden'
    }}>
      <ProjectList 
        projects={sortedProjects} 
        refetch={refetch} 
      />
    </div>
  )
}

export default ProjectSummaryPage